<template>
  <button class="scroll-button" @click="scrollToPosition" @dblclick.stop>
    <Icons :icon="icon" height="22px" width="22px" />
  </button>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";
export default {
  components: {
    Icons,
  },
  props: ["icon"],
  methods: {
    scrollToPosition() {
      this.$emit("scrollTo");
    },
  },
};
</script>

<style scoped>
.scroll-button {
  position: absolute;
  bottom: 10px;
  right: 30px;
  width: 35px;
  height: 35px;
  background-color: var(--custom-color3);
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 8px var(--custom-color5);
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: gentle-move 1s infinite alternate;
  z-index: 1000;
  transition: transform 0.3s;
}
.scroll-button:hover svg {
  fill: var(--custom-color1) !important;
}

@keyframes gentle-move {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-3px);
  }
}
</style>
